import * as React from 'react';
import { t } from '@reos/i18n';
import { Card } from './CaseUiPrimitives.js';
import {
  approveCeeExtraOwners,
  getCeeExtraOwnersOffer,
  type CeeExtraOwnersOffer,
} from '../lib/human-tasks-api.js';

const cs = { locale: 'cs' } as const;

/**
 * Krok CEE1 bod 2a — „Ověřit exekuce u dalších N vlastníků — N × cena Kč
 * z kreditu". Komplet overi samo nejvys `CEE_INCLUDED_OWNERS` vlastniku;
 * dalsi jen po potvrzeni maklere. Text tlacitka sklada server z katalogu
 * (`dd.cee.extraOwners.offer`), aby cena v textu byla tataz, jakou API vidi.
 * Bez nabidky karta nevznikne vubec.
 */
export function CeeExtraOwnersCard({ caseId }: { caseId: string }): React.JSX.Element | null {
  const [offer, setOffer] = React.useState<CeeExtraOwnersOffer | null>(null);
  const [state, setState] = React.useState<'idle' | 'busy' | 'done' | 'error'>('idle');

  React.useEffect(() => {
    getCeeExtraOwnersOffer(caseId).then(setOffer, () => setOffer(null));
  }, [caseId]);

  if (offer === null) return null;
  return (
    <Card heading={t('webAdmin.humanTasks.ceeExtra.heading', cs)} hint={t('webAdmin.humanTasks.ceeExtra.hint', cs)} testId="cee-extra-owners">
      {state === 'done' ? (
        <p role="status" style={{ margin: 0 }}>
          {t('webAdmin.humanTasks.ceeExtra.done', cs)}
        </p>
      ) : (
        <button
          type="button"
          data-testid="cee-extra-owners-approve"
          disabled={state === 'busy'}
          onClick={() => {
            setState('busy');
            approveCeeExtraOwners(caseId, offer.owners).then(
              () => setState('done'),
              () => setState('error'),
            );
          }}
        >
          {offer.label}
        </button>
      )}
      {state === 'error' && (
        <p role="alert" style={{ margin: 0, color: 'var(--rh-danger)' }}>
          {t('webAdmin.humanTasks.ceeExtra.failed', cs)}
        </p>
      )}
    </Card>
  );
}
